import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMore$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMore extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e78da6f261cdad1d4f3160f378c8f586313c9f9b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '85b1bbf721b96a2adfeafd49bbac307b124bfeb6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6965e78568cccb819292ef69955ff9a48607419a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.001 10.979a1.52 1.52 0 0 1 3.04 0 1.466 1.466 0 0 1-1.52 1.52 1.466 1.466 0 0 1-1.52-1.52m5.48 0a1.52 1.52 0 1 1 3.04 0 1.52 1.52 0 0 1-3.04 0m6.999-1.52a1.52 1.52 0 1 0 0 3.04 1.52 1.52 0 0 0 0-3.04", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-more", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-more"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-more":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMore$1);
            }
            break;
    } });
}

const CosmosIconMore = CosmosIconMore$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMore, defineCustomElement };
